// extracted by mini-css-extract-plugin
module.exports = {"rating":"Rating_rating__ylrMD","disabled":"Rating_disabled__IfxXX"};